<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.ReportPage.Title_1 }}

            <p class="control" slot="right">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
        </hero-bar>

        <!-- Opened from a project table: no step rail, the report takes the width. -->
        <div class="wizard is-railless">
            <pdf-frame :src="pdfsrc" :loading="isLoading" :failed="pdfFailed" />
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import PdfFrame from '@/components/PdfFrame.vue';

    export default {
        name: 'ReportPdfPage2',
        components: {
            PdfFrame
        },
        data() {
            return {
                isLoading: false,
                pdfFailed: false,
                pdfsrc: ''
            }
        },
        mounted() {
            this.getReportPdf();

            this.$store.state.isFooterFixed = true;
        },
        beforeDestroy() {
            this.releasePdf();
        },
        methods: {
            // The report arrives as a Blob; the frame shows it from an object URL, released when
            // it is replaced or the page closes. A guest gets the viewer without its toolbar.
            showPdf(blob) {
                this.releasePdf();
                this.pdfsrc = URL.createObjectURL(blob) + (this.$store.state.memberId == 'TestMember' ? '#toolbar=0' : '');
            },
            releasePdf() {
                if (this.pdfsrc) {
                    URL.revokeObjectURL(this.pdfsrc.split('#')[0]);
                    this.pdfsrc = '';
                }
            },
            getReportPdf() {
                this.isLoading = true;
                this.pdfFailed = false;
                api.panels.getReportPdf(this.$lang.Format.Lang, this.$store.state.memberId, this.$store.state.projectId).then((res) => {
                    // Cleared on every path: it used to stay on for a guest, locking the page
                    // behind a full-page overlay with the report loaded underneath.
                    this.isLoading = false;
                    if (res.isError) {
                        this.pdfFailed = true;
                        return;
                    }
                    this.showPdf(res.data);
                });
            },
            previous() {
                router.push('/myProjects');
            }
        }
    };
</script>
